import React, { useState} from 'react';

const OpticFilterContainerViewing = ({ showLines, handleLineCheckboxChange,handleLine48CheckboxChange, showLines48,
  handleLine24CheckboxChange,showLines24,handleLine12CheckboxChange,showLines12,handleLine8CheckboxChange,showLines8,
  handleLine4CheckboxChange,showLines4,handleLine2CheckboxChange,showLines2,handleLine1CheckboxChange,
  showLines1, handleLine16CheckboxChange, showLines16,handleLine32CheckboxChange, showLines32, handleLine36CheckboxChange, showLines36,
  handleLine64CheckboxChange, showLines64, handleLine72CheckboxChange, showLines72, handleLine96CheckboxChange, showLines96, handleLine144CheckboxChange,
  showLines144, showLinesTypeSolid, showLinesTypeDashed, handleLineTypeSolidCheckboxChange, handleLineTypeDashedCheckboxChange,
  handleLinesDenominationCheckboxChange, showLineDenomination, handleLineTypeBasementCheckboxChange, showLinesTypeBasement,
  handleLineTypeFacadeCheckboxChange, showLinesTypeFacade, handleLineTypeLoftCheckboxChange, showLinesTypeLoft, handleLineTypeRoofCheckboxChange, showLinesTypeRoof,
  handleLineAirBetweenHousesCheckboxChange, showAirBetweenHouses, handleLineAirPillarsCheckboxChange, showAirPillars, handleLine6CheckboxChange,showLines6}) => {

    const [isVisibleDiv, setIsVisibleDiv] = useState(false);

    function toggleVisibilityDiv() {
      setIsVisibleDiv(!isVisibleDiv);
    }

  return (
    <React.Fragment>
      
       <button onClick={toggleVisibilityDiv} className={isVisibleDiv ? 'buttonIsHideDrawer' : 'buttonIsHideDrawer2'}>
         {isVisibleDiv ? 'Оптоволокно: скрыть' : 'Оптоволокно: показать'}
       </button>
     
      {isVisibleDiv && ( 
        <div className='equipmentDiv' style={{marginTop: "10px",textShadow: '2px 2px 4px #242424' }}>
          <label className='typeLabelDiv'>Волоконность</label>
          <hr className='horizontalLineDrawer'/>

            <input
              type="checkbox"
              checked={showLines}
              onChange={handleLineCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Оптоволокно</label>
             <br/>
              <br/>
            <input
              type="checkbox"
              checked={showLines144}
              onChange={handleLine144CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>144 волокона</label>
          
            <br/>
            <input
              type="checkbox"
              checked={showLines96}
              onChange={handleLine96CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>96 волокон</label>
            <br/>
        
            <input
              type="checkbox"
              checked={showLines72}
              onChange={handleLine72CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>72 волокна</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines64}
              onChange={handleLine64CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>64 волокон</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines48}
              onChange={handleLine48CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>48 волокон</label>
             <br/>
          
            <input
              type="checkbox"
              checked={showLines36}
              onChange={handleLine36CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>36 волокон</label>
            <br/>
              <input
              type="checkbox"
              checked={showLines32}
              onChange={handleLine32CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>32 волокон</label>
            
            <br/>
            <input
              type="checkbox"
              checked={showLines24}
              onChange={handleLine24CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>24 волокна</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines16}
              onChange={handleLine16CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>16 волокон</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines12}
              onChange={handleLine12CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>12 волокон</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines8}
              onChange={handleLine8CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>8 волокон</label>
             <br/>
            <input
              type="checkbox"
              checked={showLines6}
              onChange={handleLine6CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>6 волокона</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines4}
              onChange={handleLine4CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>4 волокона</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines2}
              onChange={handleLine2CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>2 волокна</label>
            <br/>
            <input
              type="checkbox"
              checked={showLines1}
              onChange={handleLine1CheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>1 волокно</label>
            <hr className='horizontalLineDrawer'/>
            <input
              type="checkbox"
              checked={showLineDenomination}
              onChange={handleLinesDenominationCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Номинал кабеля</label>
            
            <hr className='horizontalLineDrawer'/>


            <label className='typeLabelDiv'>Тип:</label>
            <hr className='horizontalLineDrawer'/>
            <input
              type="checkbox"
              checked={showLinesTypeSolid}
              onChange={handleLineTypeSolidCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Воздушка</label>
            <br/>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={showAirBetweenHouses}
                onChange={handleLineAirBetweenHousesCheckboxChange}
                style={{ marginLeft: "20px", marginRight: '5px' }}
              />
              <label style={{ marginRight: '10px', color: '#bdbdbd', lineHeight: '1' }}>
                междомовая
              </label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: "5px" }}>
              <input
                type="checkbox"
                checked={showAirPillars}
                onChange={handleLineAirPillarsCheckboxChange}
                style={{ marginLeft: "20px", marginRight: '5px' }}
              />
              <label style={{ marginRight: '10px', color: '#bdbdbd', lineHeight: '1' }}>
                по опорам
              </label>
            </div>

             {/* <input
          type="checkbox"
          //checked={visibleNumberPonBox}
          //onChange={() => handleNumberPonBoxCheckboxChange()}
          style={{marginLeft:"20px", marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>междомовая</label> */}
           
            <input
              type="checkbox"
              checked={showLinesTypeDashed}
              onChange={handleLineTypeDashedCheckboxChange}
              style={{ marginRight: '5px', marginTop: "10px" }}
            />              
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Подземка</label>
           
            <br/> <br/>
            <input
              type="checkbox"
              checked={showLinesTypeBasement}
              onChange={handleLineTypeBasementCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Подвал</label>

            <br/>
            <input
              type="checkbox"
              checked={showLinesTypeFacade}
              onChange={handleLineTypeFacadeCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Фасад</label>

            <br/>
            <input
              type="checkbox"
              checked={showLinesTypeLoft}
              onChange={handleLineTypeLoftCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Чердак</label>

             <br/>
            <input
              type="checkbox"
              checked={showLinesTypeRoof}
              onChange={handleLineTypeRoofCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Крыша</label>
            <hr className='horizontalLineDrawer'/>

          </div>
          )}
      </React.Fragment>
  );
}

export default OpticFilterContainerViewing;